const React = require('react');

// @utilities
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;
import { getFormattedString } from 'utilities/currencyHelper';
const filterLodash = require('lodash/collection/filter');
const uniq = require('lodash/array/uniq');

// @components
import { OKCheckbox } from 'commonsComponents/OKCheckbox';

const buildNotDeductMessageNGO = (charityFoundations, isTransfer = false, showMessageTransfer, valueCheck, functionHandle) => {
    if (!isTransfer) {
        let showMessage = false;
        const foundations = charityFoundations.map((charityFoundation) => {
            if (!showMessage) {
                showMessage = charityFoundation.getIn(['suggestion', 'showNotDeductibleMessage']);
            }

            if (!charityFoundation.getIn(['suggestion', 'deductible'])) {
                return charityFoundation.getIn(['suggestion', 'name'])
            }
        })

        if (showMessage) {
            return(
                <div className="hire-confirmation__deduct-check">
                    <OKCheckbox
                        idName="deduct"
                        label={
                            <FormattedText
                                value="transferSummary-adviseNGO"
                                injectedStrings={
                                    [foundations.toJS().filter(f => f).join()]
                                }
                            />
                        }
                        value={valueCheck}
                        onChange={functionHandle}
                    />
                </div>
            )
        } else {
            return true;
        }
    } else {
        if(showMessageTransfer) {
            return (
                <div className="hire-confirmation__deduct-check">
                    <OKCheckbox
                        idName="deduct"
                        label={<FormattedText value="transferSummary-adviseNGOTransfer" injectedStrings={[charityFoundations]}/>}
                        value={valueCheck}
                        onChange={functionHandle}
                    />
                </div>
            )
        } else {
            return true
        }
    }
}

const buildNotDeductMessageNGOPassport = (ngos, valueCheck, functionHandle) => {
    const foundations = ngos.filter(ngo => !ngo.deductible )
    const ngoNames = foundations.map(ngo => ngo.name );
    if (ngoNames.length !== 0) {
            return(
                <div className="hire-confirmation__deduct-check">
                    <OKCheckbox
                        idName="deduct"
                        label={
                            <FormattedText
                                value="transferSummary-adviseNGO"
                                injectedStrings={
                                    [ngoNames.join(', ')]
                                }
                            />
                        }
                        value={valueCheck}
                        onChange={functionHandle}
                    />
                </div>
            )
        } else {
            return null;
        }
}


const getNotSelectedFoundations = (data, dataToFilter) => {
    let charities;
    const listIds = data.map((charityFoundation) => {
        return charityFoundation.suggestion.ngoId;
    });

    charities = filterLodash(dataToFilter, function(foundation) {
        return(listIds.indexOf(foundation.ngoId) === -1)
    });

    return (uniq(charities, 'ngoId'));
}

let generateAmounts = (amounts, currency) => amounts.map(amount => ({
    value: amount,
    label: amount === 99999999 ? formatText('ngoAmounts-maxLimit') : getFormattedString({ amount, currency })
}));

module.exports = {
    buildNotDeductMessageNGO,
    buildNotDeductMessageNGOPassport,
    getNotSelectedFoundations,
    generateAmounts,
}
